export class TimeUtils {

  public static secondsToString(seconds: number): string {
    const res: any[] = [];

    const hours = Math.floor(seconds / 3600);
    const hoursString = hours > 9 ? '' + hours : '0' + hours;
    if (hours) res.push(hoursString);

    const minutes = Math.floor((seconds - hours * 3600) / 60);
    const minString = minutes > 9 ? '' + minutes : '0' + minutes;
    res.push(minString);

    const sec = Math.floor(seconds - hours * 3600 - minutes * 60);
    const secString = sec > 9 ? '' + sec : '0' + sec;
    res.push(secString);

    return res.join(':');
  }

  public static pause(time: number): Promise<void> {
    return new Promise(resolve => {
      setTimeout(resolve, time)
    })
  }
}
